var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:0.925;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#000000;stroke-linecap:square;stroke-miterlimit:10;}\r\n\t.st3{opacity:0.25;fill:#FF0000;}\r\n\t.st4{fill:none;}\r\n\t.st5{stroke:#000000;stroke-miterlimit:10;}\r\n\t.st6{fill:#606060;}\r\n\t.st7{fill:none;stroke:#000000;stroke-width:0.8667;stroke-miterlimit:10;}\r\n\t.st8{opacity:0.99;fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st9{fill:none;stroke:#B3B3B3;stroke-miterlimit:10;}\r\n\t.st10{fill:#B3B3B3;}\r\n\t.st11{fill:none;stroke:#B3B3B3;stroke-linecap:square;stroke-miterlimit:10;}\r\n\t.st12{fill:none;stroke:#000000;stroke-width:0.9878;stroke-miterlimit:10;}\r\n\t.st13{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st14{fill:none;stroke:#000000;stroke-width:1.25;stroke-miterlimit:10;}\r\n\t.st15{fill:#FBB03B;}\r\n\t.st16{fill:none;stroke:#000000;stroke-width:1.9467;stroke-miterlimit:10;}\r\n\t.st17{fill:none;stroke:#000000;stroke-width:1.539;stroke-miterlimit:10;}\r\n\t.st18{fill:none;stroke:#000000;stroke-width:1.3765;stroke-miterlimit:10;}\r\n\t.st19{opacity:0.34;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M10.1164,13.0934h-1c0-0.6494,0.0234-1.2803,0.3057-1.8564c0.2754-0.5566,0.7324-0.7998,1.1357-1.0137 c0.0879-0.0459,0.1758-0.0928,0.2646-0.1445c0.5049-0.2939,0.8936-0.8359,1.0381-1.4502c0.1465-0.624-0.0146-1.2676-0.4414-1.7656 c-0.418-0.4873-1.0107-0.7373-1.6426-0.6924C9.0402,6.2272,8.3302,6.7438,8.05,7.4274L7.1242,7.0485 C7.55,6.0124,8.5851,5.2595,9.7003,5.1735c0.9512-0.0693,1.8506,0.3066,2.4785,1.0391c0.627,0.7314,0.8721,1.7207,0.6543,2.6445 c-0.2061,0.877-0.7695,1.6562-1.5078,2.0859c-0.1006,0.0586-0.2002,0.1113-0.2988,0.1641 c-0.3672,0.1943-0.5811,0.3174-0.707,0.5723C10.132,12.0612,10.1164,12.5456,10.1164,13.0934z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 9.649,
    cy: 14.7425,
    r: 0.6262
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M10.0002,17.9997c-4.4111,0-8-3.5889-8-8s3.5889-8,8-8s8,3.5889,8,8S14.4113,17.9997,10.0002,17.9997z  M10.0002,2.9997c-3.8594,0-7,3.1406-7,7s3.1406,7,7,7s7-3.1406,7-7S13.8595,2.9997,10.0002,2.9997z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp20);
export default __webpack_public_path__ + "static/media/Help20.7ea2f041549abf933e6f8f3b6302c4dd.svg";
export { ForwardRef as ReactComponent };